import { FuseNavigation } from '@fuse/types';


// VENDOR and COMPANY
export const navigation: FuseNavigation[] = [
    {
        // id: 'applications',
        id: '',
        // title: 'VENDORINFRA',
        title: '',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        children: [

            //  Vendor Dashboard
            {
                id: 'vnDashboard',
                title: 'Dashboard',
                type: 'item',
                icon: 'dashboard',
                url: '/vendor/dashbaord',

            },

            // Company Dashboard
            {
                id: 'cmDashboard',
                title: 'Dashboard',
                type: 'item',
                icon: 'dashboard',
                url: '/company/cmdashbaord',
            },

            {
                id: 'cmTeam Members',
                title: 'Mail',
                type: 'item',
                icon: 'email',
                url: '/mail',
                badge: {
                    title: '0',
                    bg: '#F44336',
                    fg: '#ffffff'
                }
            },
            {
                id: 'vnMail',
                title: 'Mail',
                type: 'item',
                icon: 'email',
                url: '/vendor-mail',
                badge: {
                    title: '0',
                    bg: '#F44336',
                    fg: '#ffffff'
                }
            },

            {
                id: 'cmProfile',
                title: 'Profile',
                type: 'item',
                icon: 'person',
                url: '/company/cmprofiles/profilemain',
            },

            {
                id: 'vnProfile',
                title: 'Profile',
                type: 'item',
                icon: 'person',
                url: '/vendor/vnprofiles/profilesmain',

            },

            {
                id: 'cmVendors',
                title: 'Vendors',
                type: 'item',
                icon: 'people',
                url: '/company/cmvendorsmain',
            },

            {
                id: 'cmProjects',
                title: 'Projects',
                type: 'item',
                icon: 'receipt',
                url: '/company/projectmain',
            },

            {
                id: 'vnProjects',
                title: 'Projects',
                type: 'item',
                icon: 'receipt',
                url: '/vendor/projects',

            },

            {
                id: 'cmRequestProposalSide',
                title: 'Request Proposal',
                type: 'item',
                icon: 'library_books',
                url: '/company/cmrequestproposalmain',
            },
            {
                id: 'vnProposalsRequested',
                title: 'Proposals Requested',
                type: 'item',
                icon: 'library_books',
                url: '/vendor/requestProposal',

            },

            {
                id: 'cmSector Intelligence',
                title: 'Sector Intelligence',
                type: 'item',
                icon: 'filter_tilt_shift',
                url: '/company/sectorintelligence',
            },
            {
                id: 'vnSector Intelligence',
                title: 'Sector Intelligence',
                type: 'item',
                icon: 'filter_tilt_shift',
                url: '/company/sectorintelligence'//'/vendor/sectorIntelligence',
            },

            {
                id: 'comman',
                title: 'Plants & Equipment',
                type: 'collapsable',
                icon: 'build',
                children: [
                    {
                        id: 'catogory',
                        title: 'All Plants & Equipment',
                        type: 'item',
                        icon: 'build',
                        url: '/company/cmequipments/allequipments',
                        exactMatch: true
                    },
                    {
                        id: 'catogory',
                        title: 'My Plants & Equipment',
                        type: 'item',
                        icon: 'build',
                        url: '/company/cmequipments/myequipments',
                        exactMatch: true
                    },
                    {
                        id: 'catogory',
                        title: 'Short Listed ',
                        type: 'item',
                        icon: 'build',
                        url: '/company/cmequipments/selectedequipments',
                        exactMatch: true
                    },
                    {
                        id: 'common',
                        title: 'Equipment Requirements',
                        type: 'item',
                        icon: 'build',
                        url: '/company/allequipmentsrequirements',
                        exactMatch: true
                    }
                ]
            },

            // ================================================================================
            // {
            //     id: 'comman',
            //     title: 'Equipment Requirements',
            //     type: 'collapsable',
            //     icon: 'build',
            //     children: [
            //         {
            //             id: 'common',
            //             title: 'All Equipments Requirements',
            //             type: 'item',
            //             icon: 'build',
            //             url: '/company/cmallequipmentsrequirements',
            //             exactMatch: true
            //         },
            //         {
            //             id: 'common',
            //             title: 'My Equipment Requirements',
            //             type: 'item',
            //             icon: 'build',
            //             url: '/company/allequipmentsrequirements',
            //             exactMatch: true
            //         },

            //     ]
            // },
            // ================================================================================

            {
                id: 'cmRates',
                title: 'Rates',
                type: 'item',
                icon: 'featured_play_list',
                url: '/company/cmrates',
            },

            {
                id: 'comman',
                title: 'Insurance',
                type: 'collapsable',
                icon: 'featured_play_list',
                children: [
                    {
                        id: 'catogory',
                        title: 'Project Insurance',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cminsurance/cmprojectinsurancelist',
                        exactMatch: true
                    },
                    {
                        id: 'catogory',
                        title: 'Plants & Equipment Insurance',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cminsurance/cmplantsandequipmentinsurancelist',
                        exactMatch: true
                    },

                ]
            },


            {
                id: 'comman',
                title: 'Financing',
                type: 'collapsable',
                icon: 'featured_play_list',
                children: [
                    {
                        id: 'catogory',
                        title: 'Project Financing',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cmfinance/cmprojectfinancelist',
                        exactMatch: true
                    },

                    {
                        id: 'catogory',
                        title: 'Plants & Equipment Financing',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cmfinance/cmplantesandequipmentfinancelist',
                        exactMatch: true
                    }

                ]
            },


            // ========================================================================
            {
                id: 'comman',
                title: 'Tender',
                type: 'item',
                icon: 'featured_play_list',
                url: '/company/tenders',
            },
            // ========================================================================

            {
                id: 'vnFeedback',
                title: 'Rates',
                type: 'item',
                icon: 'featured_play_list',
                url: '/vendor/vnrating',
            },

            {
                id: 'comman',
                title: 'Industry Updates',
                type: 'item',
                icon: 'folder',
                url: '/company/cmdocumentrepository',
            },
            {
                id: 'cmFeedback',
                title: 'Support Request',
                type: 'item',
                icon: 'feedback',
                url: '/company/cmfeedback',
            },
            {
                id: 'teamMembers',
                title: 'Team Members',
                type: 'item',
                icon: 'people',
                url: '/company/cmteammembersnew/cmteammembersmain',

            },

            {
                id: 'doc',
                title: 'How To Use',
                type: 'item',
                icon: 'folder',
                url: '/company/doc-help',
                exactMatch: true
            },

            {
                id: 'reports',
                title: 'Reports',
                type: 'collapsable',
                icon: 'help_outline',
                children: [
                    {
                        id: 'singleReport',
                        title: 'Project Report',
                        type: 'item',
                        icon: '',
                        url: '/company/projectmain',
                        // exactMatch: true
                    },
                    {
                        id: 'allReports',
                        title: 'All Projects Report',
                        type: 'item',
                        icon: '',
                        url: '/company/projectList',

                    }

                ]
            },
            //New

            //End
            {
                id: 'comman',
                title: 'Setting',
                type: 'collapsable',
                icon: 'settings',
                children: [
                    {
                        id: 'catogory',
                        title: 'Change Password',
                        type: 'item',
                        icon: '',
                        url: '/pages/change-password',
                        exactMatch: true
                    },
                    {
                        id: 'Logout',
                        title: 'Logout',
                        type: 'item',
                        icon: '',
                        url: 'login-2',

                    }

                ]
            },

        ]
    }
];


// BOTH LOGIN
export const navigation2: FuseNavigation[] = [
    {
        id: 'applications',
        // id: '',
        // title: 'VENDORINFRA',
        title: '',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        children: [
            {
                id: 'comman',
                title: 'As Company',
                type: 'collapsable',
                icon: 'account_balance',
                children: [
                    // Company Dashboard
                    {
                        id: 'cmDashboard',
                        title: 'Dashboard',
                        type: 'item',
                        icon: 'dashboard',
                        url: '/company/cmdashbaord',
                    },

                    {
                        id: 'cmTeam Members',
                        title: 'Mail',
                        type: 'item',
                        icon: 'email',
                        url: '/mail',
                        badge: {
                            title: '0',
                            bg: '#F44336',
                            fg: '#ffffff'
                        }
                    },

                    {
                        id: 'cmProfile',
                        title: 'Profile',
                        type: 'item',
                        icon: 'person',
                        url: '/company/cmprofiles/profilemain',
                    },
                    {
                        id: 'cmVendors',
                        title: 'Vendors',
                        type: 'item',
                        icon: 'people',
                        url: '/company/cmvendorsmain',
                    },

                    {
                        id: 'cmProjects',
                        title: 'Projects',
                        type: 'item',
                        icon: 'receipt',
                        url: '/company/projectmain',
                    },
                    {
                        id: 'cmRequestProposalSide',
                        title: 'Request Proposal',
                        type: 'item',
                        icon: 'library_books',
                        url: '/company/cmrequestproposalmain',
                    },
                    // {
                    //     id: 'cmSector Intelligence',
                    //     title: 'Sector Intelligence',
                    //     type: 'item',
                    //     icon: 'filter_tilt_shift',
                    //     url: '/company/sectorintelligence',
                    // },

                ]
            },


            // Vendor
            {
                id: 'comman',
                title: 'As Vendor',
                type: 'collapsable',
                icon: 'people',
                children: [
                    // Company Dashboard
                    //  Vendor Dashboard
                    {
                        id: 'vnDashboard',
                        title: 'Dashboard',
                        type: 'item',
                        icon: 'dashboard',
                        url: '/vendor/dashbaord',

                    },
                    {
                        id: 'vnMail',
                        title: 'Mail',
                        type: 'item',
                        icon: 'email',
                        url: '/vendor-mail',
                        badge: {
                            title: '0',
                            bg: '#F44336',
                            fg: '#ffffff'
                        }
                    },
                    {
                        id: 'vnProfile',
                        title: 'Profile',
                        type: 'item',
                        icon: 'person',
                        url: '/vendor/vnprofiles/profilesmain',

                    },
                    {
                        id: 'vnProjects',
                        title: 'Projects',
                        type: 'item',
                        icon: 'receipt',
                        url: '/vendor/projects',

                    },
                    {
                        id: 'vnProposalsRequested',
                        title: 'Proposals Requested',
                        type: 'item',
                        icon: 'library_books',
                        url: '/vendor/requestProposal',

                    },
                    // {
                    //     id: 'vnSector Intelligence',
                    //     title: 'Sector Intelligence',
                    //     type: 'item',
                    //     icon: 'filter_tilt_shift',
                    //     url: '/vendor/sectorIntelligence',
                    // }
                ]
            },
            // End of vendor
            {
                id: 'cmSector Intelligence',
                title: 'Sector Intelligence',
                type: 'item',
                icon: 'filter_tilt_shift',
                url: '/company/sectorintelligence',
            },

            {
                id: 'comman',
                title: 'Plants & Equipment',
                type: 'collapsable',
                icon: 'build',
                children: [
                    {
                        id: 'catogory',
                        title: 'All Plants & Equipment',
                        type: 'item',
                        icon: 'build',
                        url: '/company/cmequipments/allequipments',
                        exactMatch: true
                    },
                    {
                        id: 'catogory',
                        title: 'My Plants & Equipment',
                        type: 'item',
                        icon: 'build',
                        url: '/company/cmequipments/myequipments',
                        exactMatch: true
                    },
                    {
                        id: 'catogory',
                        title: 'Short Listed ',
                        type: 'item',
                        icon: 'build',
                        url: '/company/cmequipments/selectedequipments',
                        exactMatch: true
                    },
                    {
                        id: 'common',
                        title: 'Equipment Requirements',
                        type: 'item',
                        icon: 'build',
                        url: '/company/allequipmentsrequirements',
                        exactMatch: true
                    }

                ]
            },


            // ================================================================================
            // {
            //     id: 'comman',
            //     title: 'Equipment Requirements',
            //     type: 'collapsable',
            //     icon: 'build',
            //     children: [
            //         {
            //             id: 'common',
            //             title: 'All Equipments Requirements',
            //             type: 'item',
            //             icon: 'build',
            //             url: '/company/cmallequipmentsrequirements',
            //             exactMatch: true
            //         },
            //         {
            //             id: 'common',
            //             title: 'My Equipment Requirements',
            //             type: 'item',
            //             icon: 'build',
            //             url: '/company/allequipmentsrequirements',
            //             exactMatch: true
            //         },

            //     ]
            // },
            // ================================================================================


            // {
            //     id: 'vnFeedback',
            //     title: 'Rates',
            //     type: 'item',
            //     icon: 'featured_play_list',
            //     url: '/vendor/vnrating',
            // },
            {
                id: 'cmRates',
                title: 'Rates',
                type: 'item',
                icon: 'featured_play_list',
                url: '/company/cmrates',
            },

            {
                id: 'comman',
                title: 'Insurance',
                type: 'collapsable',
                icon: 'featured_play_list',
                children: [
                    {
                        id: 'catogory',
                        title: 'Project Insurance',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cminsurance/cmprojectinsurancelist',
                        exactMatch: true
                    },
                    {
                        id: 'catogory',
                        title: 'Plants & Equipment Insurance',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cminsurance/cmplantsandequipmentinsurancelist',
                        exactMatch: true
                    },

                ]
            },



            {
                id: 'comman',
                title: 'Financing',
                type: 'collapsable',
                icon: 'featured_play_list',
                children: [
                    {
                        id: 'catogory',
                        title: 'Project Financing',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cmfinance/cmprojectfinancelist',
                        exactMatch: true
                    },

                    {
                        id: 'catogory',
                        title: 'Plants & Equipment Financing',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cmfinance/cmplantesandequipmentfinancelist',
                        exactMatch: true
                    }

                ]
            },


            // ========================================================================
            {
                id: 'comman',
                title: 'Tender',
                type: 'item',
                icon: 'featured_play_list',
                url: '/company/tenders',
            },
            // ========================================================================

            {
                id: 'comman',
                title: 'Industry Updates',
                type: 'item',
                icon: 'folder',
                url: '/company/cmdocumentrepository',
            },
            {
                id: 'cmFeedback',
                title: 'Support Request',
                type: 'item',
                icon: 'feedback',
                url: '/company/cmfeedback',
            },
            {
                id: 'cmTeam Members',
                title: 'Team Members',
                type: 'item',
                icon: 'people',
                url: '/company/cmteammembersnew/cmteammembersmain',

            },

            {
                id: 'doc',
                title: 'How To Use',
                type: 'item',
                icon: 'folder',
                url: '/company/doc-help',
                exactMatch: true
            },

            {
                id: 'reports',
                title: 'Reports',
                type: 'collapsable',
                icon: 'help_outline',
                children: [
                    {
                        id: 'singleReport',
                        title: 'Project Report',
                        type: 'item',
                        icon: '',
                        url: '/company/projectmain',
                        // exactMatch: true
                    },
                    {
                        id: 'allReports',
                        title: 'All Projects Report',
                        type: 'item',
                        icon: '',
                        url: '/company/projectList',

                    }

                ]
            },

            {
                id: 'comman',
                title: 'Setting',
                type: 'collapsable',
                icon: 'settings',
                children: [
                    {
                        id: 'catogory',
                        title: 'Change Password',
                        type: 'item',
                        icon: '',
                        url: '/pages/change-password',
                        exactMatch: true
                    },
                    {
                        id: 'Logout',
                        title: 'Logout',
                        type: 'item',
                        icon: '',
                        url: 'login-2',

                    }

                ]
            },

        ]
    }
];






// TEAM MEMBER LOGIN 
export const navigationteammember: FuseNavigation[] = [
    {
        // id: 'applications',
        id: '',
        // title: 'VENDORINFRA',
        title: '',
        translate: '',//'NAV.APPLICATIONS',
        type: 'group',
        children: [
            {
                id: 'cmTeam Members',
                title: 'Mail',
                type: 'item',
                icon: 'email',
                url: '/mail',
                badge: {
                    title: '0',
                    bg: '#F44336',
                    fg: '#ffffff'
                }
            },

            {
                id: 'cmProfile',
                title: 'Profile',
                type: 'item',
                icon: 'person',
                url: '/company/cmprofiles/profilemain',
            },

            {
                id: 'vnProfile',
                title: 'Profile',
                type: 'item',
                icon: 'person',
                url: '/vendor/vnprofiles/profilesmain',

            },

            {
                id: 'cmVendors',
                title: 'Vendors',
                type: 'item',
                icon: 'people',
                url: '/company/cmvendorsmain',
            },

            {
                id: 'cmProjects',
                title: 'Projects',
                type: 'item',
                icon: 'receipt',
                url: '/company/projectmain',
            },

            {
                id: 'vnProjects',
                title: 'Projects',
                type: 'item',
                icon: 'receipt',
                url: '/vendor/projects',

            },

            {
                id: 'cmRequestProposalSide',
                title: 'Request Proposal',
                type: 'item',
                icon: 'library_books',
                url: '/company/cmrequestproposalmain',
            },
            {
                id: 'vnProposalsRequested',
                title: 'Proposals Requested',
                type: 'item',
                icon: 'library_books',
                url: '/vendor/requestProposal',

            },



            {
                id: 'comman',
                title: 'Plants & Equipment',
                type: 'collapsable',
                icon: 'build',
                children: [
                    {
                        id: 'catogory',
                        title: 'All Plants & Equipment',
                        type: 'item',
                        icon: 'build',
                        url: '/company/cmequipments/allequipments',
                        exactMatch: true
                    },
                    {
                        id: 'catogory',
                        title: 'My Plants & Equipment',
                        type: 'item',
                        icon: 'build',
                        url: '/company/cmequipments/myequipments',
                        exactMatch: true
                    },
                    {
                        id: 'catogory',
                        title: 'Short Listed ',
                        type: 'item',
                        icon: 'build',
                        url: '/company/cmequipments/selectedequipments',
                        exactMatch: true
                    },
                    {
                        id: 'common',
                        title: 'Equipment Requirements',
                        type: 'item',
                        icon: 'build',
                        url: '/company/allequipmentsrequirements',
                        exactMatch: true
                    }
                ]
            },

            // ================================================================================
            // {
            //     id: 'comman',
            //     title: 'Equipment Requirements',
            //     type: 'collapsable',
            //     icon: 'build',
            //     children: [
            //         {
            //             id: 'common',
            //             title: 'All Equipments Requirements',
            //             type: 'item',
            //             icon: 'build',
            //             url: '/company/cmallequipmentsrequirements',
            //             exactMatch: true
            //         },
            //         {
            //             id: 'common',
            //             title: 'My Equipment Requirements',
            //             type: 'item',
            //             icon: 'build',
            //             url: '/company/allequipmentsrequirements',
            //             exactMatch: true
            //         },

            //     ]
            // },
            // ================================================================================

            {
                id: 'cmRates',
                title: 'Rates',
                type: 'item',
                icon: 'featured_play_list',
                url: '/company/cmrates',
            },

            {
                id: 'comman',
                title: 'Insurance',
                type: 'collapsable',
                icon: 'featured_play_list',
                children: [
                    {
                        id: 'catogory',
                        title: 'Project Insurance',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cminsurance/cmprojectinsurancelist',
                        exactMatch: true
                    },
                    {
                        id: 'catogory',
                        title: 'Plants & Equipment Insurance',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cminsurance/cmplantsandequipmentinsurancelist',
                        exactMatch: true
                    },

                ]
            }, 



            {
                id: 'comman',
                title: 'Financing',
                type: 'collapsable',
                icon: 'featured_play_list',
                children: [
                    {
                        id: 'catogory',
                        title: 'Project Financing',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cmfinance/cmprojectfinancelist',
                        exactMatch: true
                    },

                    {
                        id: 'catogory',
                        title: 'Plants & Equipment Financing',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cmfinance/cmplantesandequipmentfinancelist',
                        exactMatch: true
                    }

                ]
            },


            {
                id: 'vnFeedback',
                title: 'Rates',
                type: 'item',
                icon: 'featured_play_list',
                url: '/vendor/vnrating',
            },
            {
                id: 'cmFinancing',
                title: 'Financing',
                type: 'item',
                icon: 'featured_play_list',
                children: [
                    {
                        id: 'cmRates',
                        title: 'Project Financing',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cmFinancing/',
                    }
                ]
            },


            // ========================================================================
            {
                id: 'comman',
                title: 'Tender',
                type: 'item',
                icon: 'featured_play_list',
                url: '/company/tenders',
            },
            // ========================================================================


            {
                id: 'cmSector Intelligence',
                title: 'Sector Intelligence',
                type: 'item',
                icon: 'filter_tilt_shift',
                url: '/company/sectorintelligence',
            },
            {
                id: 'vnSector Intelligence',
                title: 'Sector Intelligence',
                type: 'item',
                icon: 'filter_tilt_shift',
                url: '/company/sectorintelligence'//'/vendor/sectorIntelligence',
            },

            {
                id: 'comman',
                title: 'Industry Updates',
                type: 'item',
                icon: 'folder',
                url: '/company/cmdocumentrepository',
            },
            {
                id: 'cmFeedback',
                title: 'Support Request',
                type: 'item',
                icon: 'feedback',
                url: '/company/cmfeedback',
            },
            // {
            //     id: 'cmTeam Members',
            //     title: 'Team Members',
            //     type: 'item',
            //     icon: 'people',
            //     url: '/company/cmteammembersnew/cmteammembersmain',

            // },

            {
                id: 'doc',
                title: 'How To Use',
                type: 'item',
                icon: 'folder',
                url: '/company/doc-help',
                exactMatch: true
            },

            {
                id: 'reports',
                title: 'Reports',
                type: 'collapsable',
                icon: 'help_outline',
                children: [
                    {
                        id: 'singleReport',
                        title: 'Project Report',
                        type: 'item',
                        icon: '',
                        url: '/company/projectmain',
                        // exactMatch: true
                    },
                    {
                        id: 'allReports',
                        title: 'All Projects Report',
                        type: 'item',
                        icon: '',
                        url: '/company/projectList',

                    }

                ]
            },

            {
                id: 'comman',
                title: 'Setting',
                type: 'collapsable',
                icon: 'settings',
                children: [
                    {
                        id: 'catogory',
                        title: 'Change Password',
                        type: 'item',
                        icon: '',
                        url: '/pages/change-password',
                        exactMatch: true
                    },
                    {
                        id: 'Logout',
                        title: 'Logout',
                        type: 'item',
                        icon: '',
                        url: 'login-2',

                    }

                ]
            },

        ]
    }
];







// For Free user with both Login
export const paymentNavigation: FuseNavigation[] = [
    {
        id: 'applications-free',
        // title: 'VENDORINFRA',
        title: '',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        children: [
            {
                id: 'commanfree',
                title: 'As Company',
                type: 'collapsable',
                icon: 'account_balance',
                children: [
                    // Company Dashboard
                    {
                        id: 'cmDashboardfree',
                        title: 'Dashboard',
                        type: 'item',
                        icon: 'dashboard',
                        url: '/company/cmdashbaord',
                        exactMatch: true
                    },

                    {
                        id: 'cmTeam Membersfree',
                        title: 'Mail',
                        type: 'item',
                        icon: 'email',
                        url: '/pages/pricing-1',
                        exactMatch: false,
                        badge: {
                            title: '0',
                            bg: '#F44336',
                            fg: '#ffffff'
                        }
                    },

                    {
                        id: 'cmProfile-free',
                        title: 'Profile',
                        type: 'item',
                        icon: 'person',
                        url: '/company/cmprofiles/profilemain',
                    },
                    {
                        id: 'cmVendors-free',
                        title: 'Vendors',
                        type: 'item',
                        icon: 'people',
                        url: '/pages/pricing-23',
                    },

                    {
                        id: 'cmProjects-free',
                        title: 'Projects',
                        type: 'item',
                        icon: 'receipt',
                        url: '/pages/pricing-3',
                    },
                    {
                        id: 'cmRequestProposalSide-free',
                        title: 'Request Proposal',
                        type: 'item',
                        icon: 'library_books',
                        url: '/pages/pricing-4',
                    },
                ]
            },


            // Vendor
            {
                id: 'comman-free',
                title: 'As Vendor',
                type: 'collapsable',
                icon: 'people',
                children: [
                    //  Vendor Dashboard
                    {
                        id: 'vnDashboard-free',
                        title: 'Dashboard',
                        type: 'item',
                        icon: 'dashboard',
                        url: '/vendor/dashbaord',

                    },
                    {
                        id: 'vnMail-free',
                        title: 'Mail',
                        type: 'item',
                        icon: 'email',
                        url: '/pages/pricing-6',
                        badge: {
                            title: '0',
                            bg: '#F44336',
                            fg: '#ffffff'
                        }
                    },
                    {
                        id: 'vnProfile-free',
                        title: 'Profile',
                        type: 'item',
                        icon: 'person',
                        url: '/vendor/vnprofiles/profilesmain',

                    },
                    {
                        id: 'vnProjects-free',
                        title: 'Projects',
                        type: 'item',
                        icon: 'receipt',
                        url: '/pages/pricing-8',

                    },
                    {
                        id: 'vnProposalsRequested-free',
                        title: 'Proposals Requested',
                        type: 'item',
                        icon: 'library_books',
                        url: '/pages/pricing-9',

                    },
                ]
            },
            // End of vendor
            {
                id: 'cmSector Intelligence-free',
                title: 'Sector Intelligence',
                type: 'item',
                icon: 'filter_tilt_shift',
                url: '/company/sectorintelligence',
            },

            {
                id: 'comman-free',
                title: 'Plants & Equipment',
                type: 'collapsable',
                icon: 'build',
                children: [
                    {
                        id: 'catogory-free',
                        title: 'All Plants & Equipment',
                        type: 'item',
                        icon: 'build',
                        url: '/company/cmequipments/allequipments',
                        exactMatch: true
                    },
                    {
                        id: 'catogory-free',
                        title: 'My Plants & Equipment',
                        type: 'item',
                        icon: 'build',
                        url: '/pages/pricing-12',
                        exactMatch: true
                    },
                    {
                        id: 'catogory-free',
                        title: 'Short Listed ',
                        type: 'item',
                        icon: 'build',
                        url: '/company/cmequipments/selectedequipments',
                        exactMatch: true
                    },
                    {
                        id: 'common',
                        title: 'Equipment Requirements',
                        type: 'item',
                        icon: 'build',
                        url: '/company/allequipmentsrequirements',
                        exactMatch: true
                    }
                ]
            },

            // ================================================================================

            // {
            //     id: 'comman',
            //     title: 'Equipment Requirements',
            //     type: 'collapsable',
            //     icon: 'build',
            //     children: [
            //         {
            //             id: 'common',
            //             title: 'All Equipments Requirements',
            //             type: 'item',
            //             icon: 'build',
            //             url: '/company/cmallequipmentsrequirements',
            //             exactMatch: true
            //         },
            //         {
            //             id: 'common',
            //             title: 'My Equipments Requirements',
            //             type: 'item',
            //             icon: 'build',
            //             url: '/company/allequipmentsrequirements',
            //             exactMatch: true
            //         },

            //     ]
            // },
            // ================================================================================

            {
                id: 'cmRates-free',
                title: 'Rates',
                type: 'item',
                icon: 'featured_play_list',
                url: '/company/cmrates',
            },

            {
                id: 'comman',
                title: 'Insurance',
                type: 'collapsable',
                icon: 'featured_play_list',
                children: [
                    {
                        id: 'catogory',
                        title: 'Project Insurance',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cminsurance/cmprojectinsurancelist',
                        exactMatch: true
                    },
                    {
                        id: 'catogory',
                        title: 'Plants & Equipment Insurance',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cminsurance/cmplantsandequipmentinsurancelist',
                        exactMatch: true
                    },

                ]
            },



            {
                id: 'comman',
                title: 'Financing',
                type: 'collapsable',
                icon: 'featured_play_list',
                children: [
                    {
                        id: 'catogory',
                        title: 'Project Financing',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cmfinance/cmprojectfinancelist',
                        exactMatch: true
                    },

                    {
                        id: 'catogory',
                        title: 'Plants & Equipment Financing',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cmfinance/cmplantesandequipmentfinancelist',
                        exactMatch: true
                    }

                ]
            },


            {
                id: 'comman-free',
                title: 'Industry Updates',
                type: 'item',
                icon: 'folder',
                url: '/pages/pricing-15',
            },
            {
                id: 'cmFeedback-free',
                title: 'Support Request',
                type: 'item',
                icon: 'feedback',
                url: '/company/cmfeedback',
            },
            {
                id: 'cmTeam Members-free',
                title: 'Team Members',
                type: 'item',
                icon: 'people',
                url: '/pages/pricing-17',

            },

            {
                id: 'doc',
                title: 'How To Use',
                type: 'item',
                icon: 'folder',
                url: '/company/doc-help',
                exactMatch: true
            },

            {
                id: 'reports-free',
                title: 'Reports',
                type: 'collapsable',
                icon: 'help_outline',
                children: [
                    {
                        id: 'singleReport-free',
                        title: 'Project Report',
                        type: 'item',
                        icon: '',
                        url: '/pages/pricing-20',
                        // exactMatch: true
                    },
                    {
                        id: 'allReports-free',
                        title: 'All Projects Report',
                        type: 'item',
                        icon: '',
                        url: '/pages/pricing-21',
                    }
                ]
            },

            {
                id: 'comman-free',
                title: 'Setting',
                type: 'collapsable',
                icon: 'settings',
                children: [
                    {
                        id: 'catogory-free',
                        title: 'Change Password',
                        type: 'item',
                        icon: '',
                        url: '/pages/change-password',
                        exactMatch: true
                    },
                    {
                        id: 'Logout',
                        title: 'Logout',
                        type: 'item',
                        icon: '',
                        url: 'login-2',

                    }

                ]
            },

        ]
    }
];




// For Free user with Vendor Login
export const paymentNavigation2: FuseNavigation[] = [
    {
        // id: 'applications',
        id: '',
        // title: 'VENDORINFRA',
        title: '',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        children: [

            //  Vendor Dashboard
            {
                id: 'vnDashboard_free',
                title: 'Dashboard',
                type: 'item',
                icon: 'dashboard',
                url: '/vendor/dashbaord',

            }, {
                id: 'vnMail_free',
                title: 'Mail',
                type: 'item',
                icon: 'email',
                url: '/pages/pricing-1',
                badge: {
                    title: '0',
                    bg: '#F44336',
                    fg: '#ffffff'
                }
            }, {
                id: 'vnProfile_free',
                title: 'Profile',
                type: 'item',
                icon: 'person',
                url: '/vendor/vnprofiles/profilesmain',

            },/* {
                id: 'cmVendors',
                title: 'Vendors',
                type: 'item',
                icon: 'people',
                url: '/company/cmvendorsmain',
            }, */
            {
                id: 'vnProjects_free',
                title: 'Projects',
                type: 'item',
                icon: 'receipt',
                url: '/pages/pricing-2',

            }, /*{
                id: 'cmRequestProposalSide',
                title: 'Request Proposal',
                type: 'item',
                icon: 'library_books',
                url: '/company/cmrequestproposalmain',
            },*/
            {
                id: 'vnProposalsRequested_free',
                title: 'Request Proposal',
                type: 'item',
                icon: 'library_books',
                url: '/pages/pricing-3',

            }, {
                id: 'vnSectorIntelligence_free',
                title: 'Sector Intelligence',
                type: 'item',
                icon: 'filter_tilt_shift',
                url: '/company/sectorintelligence'//'/vendor/sectorIntelligence',
            },
            {
                id: 'comman',
                title: 'Plants & Equipment',
                type: 'collapsable',
                icon: 'build',
                children: [
                    {
                        id: 'catogory_free',
                        title: 'All Plants & Equipment',
                        type: 'item',
                        icon: 'build',
                        url: '/company/cmequipments/allequipments',
                        exactMatch: true
                    },
                    {
                        id: 'catogory_free',
                        title: 'My Plants & Equipment',
                        type: 'item',
                        icon: 'build',
                        url: '/pages/pricing-4',
                        exactMatch: true
                    },
                    {
                        id: 'catogory_free',
                        title: 'Short Listed ',
                        type: 'item',
                        icon: 'build',
                        url: '/company/cmequipments/selectedequipments',
                        exactMatch: true
                    },
                    {
                        id: 'common',
                        title: 'Equipment Requirements',
                        type: 'item',
                        icon: 'build',
                        url: '/company/allequipmentsrequirements',
                        exactMatch: true
                    }
                ]
            },

            // ================================================================================
            // {
            //     id: 'comman',
            //     title: 'Equipment Requirements',
            //     type: 'collapsable',
            //     icon: 'build',
            //     children: [
            //         {
            //             id: 'common',
            //             title: 'All Equipments Requirements',
            //             type: 'item',
            //             icon: 'build',
            //             url: '/company/cmallequipmentsrequirements',
            //             exactMatch: true
            //         },
            //         {
            //             id: 'common',
            //             title: 'My Equipments Requirements',
            //             type: 'item',
            //             icon: 'build',
            //             url: '/company/allequipmentsrequirements',
            //             exactMatch: true
            //         },

            //     ]
            // },
            // ================================================================================



            {
                id: 'vnFeedback_free',
                title: 'Rates',
                type: 'item',
                icon: 'featured_play_list',
                url: '/vendor/vnrating',
            },

            {
                id: 'comman',
                title: 'Insurance',
                type: 'collapsable',
                icon: 'featured_play_list',
                children: [
                    {
                        id: 'catogory',
                        title: 'Project Insurance',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cminsurance/cmprojectinsurancelist',
                        exactMatch: true
                    },
                    {
                        id: 'catogory',
                        title: 'Plants & Equipment Insurance',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cminsurance/cmplantsandequipmentinsurancelist',
                        exactMatch: true
                    },

                ]
            },



            {
                id: 'comman',
                title: 'Financing',
                type: 'collapsable',
                icon: 'featured_play_list',
                children: [
                    {
                        id: 'catogory',
                        title: 'Project Financing',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cmfinance/cmprojectfinancelist',
                        exactMatch: true
                    },

                    {
                        id: 'catogory',
                        title: 'Plants & Equipment Financing',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cmfinance/cmplantesandequipmentfinancelist',
                        exactMatch: true
                    }

                ]
            },


            {
                id: 'comman_free',
                title: 'Industry Updates',
                type: 'item',
                icon: 'folder',
                url: '/pages/pricing-5',
            },
            {
                id: 'cmFeedback_free',
                title: 'Support Request',
                type: 'item',
                icon: 'feedback',
                url: '/company/cmfeedback',
            },
            /* {
                 id: 'teamMembers',
                 title: 'Team Members',
                 type: 'item',
                 icon: 'people',
                 url: '/company/cmteammembersnew/cmteammembersmain',
 
             },
             */
            {
                id: 'doc_free',
                title: 'How To Use',
                type: 'item',
                icon: 'folder',
                url: '/company/doc-help',
                exactMatch: true
            },

            {
                id: 'reports',
                title: 'Reports',
                type: 'collapsable',
                icon: 'help_outline',
                children: [
                    {
                        id: 'singleReport_free',
                        title: 'Project Report',
                        type: 'item',
                        icon: '',
                        url: '/pages/pricing-6',
                        // exactMatch: true
                    },
                    {
                        id: 'allReports_free',
                        title: 'All Projects Report',
                        type: 'item',
                        icon: '',
                        url: '/pages/pricing-7',

                    }

                ]
            },
            //New

            //End
            {
                id: 'comman',
                title: 'Setting',
                type: 'collapsable',
                icon: 'settings',
                children: [
                    {
                        id: 'catogory_free',
                        title: 'Change Password',
                        type: 'item',
                        icon: '',
                        url: '/pages/change-password',
                        exactMatch: true
                    },
                    {
                        id: 'Logout_free',
                        title: 'Logout',
                        type: 'item',
                        icon: '',
                        url: 'login-2',

                    }

                ]
            },

        ]
    }
];


// For Free user with Company Login
export const paymentNavigation3: FuseNavigation[] = [
    {
        // id: 'applications',
        id: '',
        // title: 'VENDORINFRA',
        title: '',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        children: [

            // Company Dashboard
            {
                id: 'cmDashboard_freecompany',
                title: 'Dashboard',
                type: 'item',
                icon: 'dashboard',
                url: '/company/cmdashbaord',
            },

            {
                id: 'cmTeam Members_freecompany',
                title: 'Mail',
                type: 'item',
                icon: 'email',
                url: '/pages/pricing-1',
                badge: {
                    title: '0',
                    bg: '#F44336',
                    fg: '#ffffff'
                }
            },

            {
                id: 'cmProfile_freecompany',
                title: 'Profile',
                type: 'item',
                icon: 'person',
                url: '/company/cmprofiles/profilemain',
            },

            {
                id: 'cmVendors_freecompany',
                title: 'Vendors',
                type: 'item',
                icon: 'people',
                url: '/pages/pricing-2',
            },

            {
                id: 'cmProjects_freecompany',
                title: 'Projects',
                type: 'item',
                icon: 'receipt',
                url: '/pages/pricing-3',
            },

            {
                id: 'cmRequestProposalSide_freecompany',
                title: 'Request Proposal',
                type: 'item',
                icon: 'library_books',
                url: '/pages/pricing-4',
            },

            {
                id: 'cmSector Intelligence_freecompany',
                title: 'Sector Intelligence',
                type: 'item',
                icon: 'filter_tilt_shift',
                url: '/company/sectorintelligence',
            },

            {
                id: 'comman_freecompany',
                title: 'Plants & Equipment',
                type: 'collapsable',
                icon: 'build',
                children: [
                    {
                        id: 'catogory_freecompany',
                        title: 'All Plants & Equipment',
                        type: 'item',
                        icon: 'build',
                        url: '/company/cmequipments/allequipments',
                        exactMatch: true
                    },
                    {
                        id: 'catogory_freecompany',
                        title: 'My Plants & Equipment',
                        type: 'item',
                        icon: 'build',
                        url: '/pages/pricing-5',
                        exactMatch: true
                    },
                    {
                        id: 'catogory_freecompany',
                        title: 'Short Listed ',
                        type: 'item',
                        icon: 'build',
                        url: '/company/cmequipments/selectedequipments',
                        exactMatch: true
                    },
                    {
                        id: 'common',
                        title: 'Equipment Requirements',
                        type: 'item',
                        icon: 'build',
                        url: '/company/allequipmentsrequirements',
                        exactMatch: true
                    }
                ]
            },

            // ================================================================================
            // {
            //     id: 'comman',
            //     title: 'Equipment Requirements',
            //     type: 'collapsable',
            //     icon: 'build',
            //     children: [
            //         {
            //             id: 'common',
            //             title: 'All Equipments Requirements',
            //             type: 'item',
            //             icon: 'build',
            //             url: '/company/cmallequipmentsrequirements',
            //             exactMatch: true
            //         },
            //         {
            //             id: 'common',
            //             title: 'My Equipments Requirements',
            //             type: 'item',
            //             icon: 'build',
            //             url: '/company/allequipmentsrequirements',
            //             exactMatch: true
            //         },

            //     ]
            // },
            // ================================================================================

            {
                id: 'cmRates_freecompany',
                title: 'Rates',
                type: 'item',
                icon: 'featured_play_list',
                url: '/company/cmrates',
            },

            {
                id: 'comman',
                title: 'Insurance',
                type: 'collapsable',
                icon: 'featured_play_list',
                children: [
                    {
                        id: 'catogory',
                        title: 'Project Insurance',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cminsurance/cmprojectinsurancelist',
                        exactMatch: true
                    },
                    {
                        id: 'catogory',
                        title: 'Plants & Equipment Insurance',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cminsurance/cmplantsandequipmentinsurancelist',
                        exactMatch: true
                    },

                ]
            },



            {
                id: 'comman',
                title: 'Financing',
                type: 'collapsable',
                icon: 'featured_play_list',
                children: [
                    {
                        id: 'catogory',
                        title: 'Project Financing',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cmfinance/cmprojectfinancelist',
                        exactMatch: true
                    },

                    {
                        id: 'catogory',
                        title: 'Plants & Equipment Financing',
                        type: 'item',
                        icon: 'featured_play_list',
                        url: '/company/cmfinance/cmplantesandequipmentfinancelist',
                        exactMatch: true
                    }

                ]
            },


            {
                id: 'comman_freecompany',
                title: 'Industry Updates',
                type: 'item',
                icon: 'folder',
                url: '/pages/pricing-6',
            },
            {
                id: 'cmFeedback_freecompany',
                title: 'Support Request',
                type: 'item',
                icon: 'feedback',
                url: '/company/cmfeedback',
            },
            {
                id: 'teamMembers_freecompany',
                title: 'Team Members',
                type: 'item',
                icon: 'people',
                url: '/pages/pricing-7',

            },
            {
                id: 'doc_freecompany',
                title: 'How To Use',
                type: 'item',
                icon: 'folder',
                url: '/company/doc-help',
                exactMatch: true
            },

            {
                id: 'reports_freecompany',
                title: 'Reports',
                type: 'collapsable',
                icon: 'help_outline',
                children: [
                    {
                        id: 'singleReport_freecompany',
                        title: 'Project Report',
                        type: 'item',
                        icon: '',
                        url: '/pages/pricing-8',
                        // exactMatch: true
                    },
                    {
                        id: 'allReports_freecompany',
                        title: 'All Projects Report',
                        type: 'item',
                        icon: '',
                        url: '/pages/pricing-9',

                    }

                ]
            },
            //New

            //End
            {
                id: 'comman_freecompany',
                title: 'Setting',
                type: 'collapsable',
                icon: 'settings',
                children: [
                    {
                        id: 'catogory_freecompany',
                        title: 'Change Password',
                        type: 'item',
                        icon: '',
                        url: '/pages/change-password',
                        exactMatch: true
                    },
                    {
                        id: 'Logout_freecompany',
                        title: 'Logout',
                        type: 'item',
                        icon: '',
                        url: 'login-2',

                    }

                ]
            },

        ]
    }
];
